import UUIDBase from '../UUIDBase'
import { Dinero as DineroType } from 'dinero.js'
import { Role } from '@/models/user/Role'
import UserAttachment from '@/models/user/UserAttachment'

export const userI18nMessages = {
  en: {
    username: 'Username',
    name: 'Name',
    email: 'Email',
    phone: 'Phone number',

    fullName: 'Full Name',

    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',

    streetAddress: 'Street Address',
    city: 'City',
    postalCode: 'Postal code',
    country: 'Country',

    employeeSalaryAmount: 'Salary',
    employeeTitle: 'Job title',
    employeeStartDate: 'Start Date',
    employeeEndDate: 'End Date',
    isOwner: 'Owner'
  },

  ar: {
    username: 'اسم المستخدم',
    name: 'الاسم',
    email: 'البريد الالكتروني',
    phone: 'رقم الهاتف',

    fullName: 'الاسم الكامل',

    gender: 'الجنس',
    genderMale: 'ذكر',
    genderFemale: 'انثى',

    streetAddress: 'العنوان',
    city: 'المدينة',
    postalCode: 'الرمز البريدي',
    country: 'الدولة',

    employeeSalaryAmount: 'الراتب الشهري',
    employeeTitle: 'المسمى الوظيفي',
    employeeStartDate: 'تاريخ بدأ الخدمة',
    employeeEndDate: 'تاريخ انتهاء الخدمة',
    isOwner: 'مالك'
  }
}

export class UserExtraProperties {
  locationIDs?: string[]
  tags?: string[]
}

export class UserPermission extends UUIDBase {
  constructor(action: string, object: string) {
    super()
    this.permission.action = action
    this.permission.object = object
  }

  permission: {
    action: string
    object: string
    id?: string
  } = { action: '', object: '' }

  userID = ''
}

export default class User extends UUIDBase {
  static ENDPOINT = '/user/users'

  username = ''
  newPassword = ''
  newPin: string|null = ''
  name = ''
  gender = ''
  avatar = ''
  roleID = ''
  role: Role = new Role('', '', [])
  email = ''
  phone = ''

  streetAddress = ''
  city = ''
  postalCode = ''
  country = ''

  employeeSalaryAmount?: number
  employeeSalaryCurrency?: string
  employeeSalaryPrecision?: number
  employeeSalaryDinero?: DineroType

  employeeTitle?: string

  employeeStartDate?: Date
  employeeEndDate?: Date

  isOwner = false

  accessToken = ''

  payrollAccountID = ''

  userPermissions = new Array<UserPermission>()

  extraProperties: UserExtraProperties = new UserExtraProperties()

  userAttachments: UserAttachment[] = []

  get fullName() {
    return `${this.name}`
  }

  static from(json: Record<string, unknown> | User): User {
    return Object.assign(new User(), json)
  }
}
